export default function noopReducer(state) {
	return state;
}
